import React, { FC } from 'react'
import * as Styles from '../../styles'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import { UnknownQuestionTableRowDisplay } from '../../tableRowDisplay'
import { Highlighted } from 'tabs/data/components/Highlighted'
import { useUnknownQuestions } from '../../context'

export type UnknownQuestionTableRowDisplayProps = {
  question: string
  similarQuestions: string[]
  mainQuestions?: string[]
  isLastThreeQuestions: boolean
}

const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.8rem',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
  },
}))(Tooltip)

const TooltipTypography: FC<{ questions: string[] }> = ({ questions }) => (
  <>
    {questions.map(question => (
      <p style={{ margin: 0, padding: '5px 0' }} key={question}>
        {question}
      </p>
    ))}
  </>
)

export const QuestionCellContent: FC<UnknownQuestionTableRowDisplayProps> = ({
  question,
  similarQuestions,
  mainQuestions,
  isLastThreeQuestions,
}) => {
  const { search } = useUnknownQuestions()
  const mainQuestionText = mainQuestions?.join('\n')

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', position: 'relative' }}>
      {similarQuestions === null ? (
        <Styles.AnswerText>
          <Highlighted text={question} highlight={search} />
        </Styles.AnswerText>
      ) : (
        <UnknownQuestionTableRowDisplay
          question={question}
          similarQuestions={similarQuestions}
          isLastThreeQuestions={isLastThreeQuestions}></UnknownQuestionTableRowDisplay>
      )}

      {mainQuestions?.length && (
        <LightTooltip title={<TooltipTypography questions={mainQuestions} />} placement="bottom">
          <Styles.Label>
            <b>{`Main: ${mainQuestionText.slice(0, 40)}${mainQuestionText.length > 40 ? '...' : ''}`}</b>
          </Styles.Label>
        </LightTooltip>
      )}
    </div>
  )
}
